/**
 * Route for `rest-json-api-format`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { RestJsonApiFormatPage } from "../features/rest-json-api-format/RestJsonApiFormatPage";

export const restJsonApiFormatRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/rest-json-api-format",
	component: RestJsonApiFormatPage,
});

export default restJsonApiFormatRoute;
